import { get } from '../utils/api';

const getAvailableWebComponents = () => get('/templates/web_components/');

export { getAvailableWebComponents };
